import React from "react";
import DateHelper from "../DateHelper/DateHelper";

class RatesDashboardRoomTypeDateOverridesDepricatd extends React.Component {

	constructor(props) {
		super(props);

		var self = this;

		this.state = {
			amount: null,
			minimum_stay: null,
			blackout: this.props.dailyRoomTypeRate ? this.props.dailyRoomTypeRate.blackout : false,
			buttons: [
	      {
	        name: I18n.t('cancel'),
	        html_attributes: [
	          'data-dismiss="modal"'
	        ]
	      },
	      {
	        name: I18n.t('submit'),
	        button_classes: ['primary'],
	        onClick: function (e) {
	          self.onSave();
	          return false;
	        },
	      },
	    ],
	    loading: false,
		};

		this.onChange = this.onChange.bind(this);
		this.onSave = this.onSave.bind(this);
	}

	render() {


		return (
			<div className="RatesDashboardRoomTypeDateOverrides">
				<div className="daily-room-type-price-row-form">
					<div className="row">
						<div className="col-xs-6">
							<div className="form-group">
								<label>{I18n.t('amount')}</label>
							  <div className="input-group input-group-currency" style={{marginLeft: 0}}>
							    <div className="input-group-addon">{I18n.t('number.currency.format.unit')}</div>
							    <CurrencyInput className="form-control" name="amount" onChange={this.onChange} onChangeEventType={true} />
							  </div>
							  <div className="default-value-helper-text">
							  	<em>{this.props.dailyRoomTypeRate && this.props.dailyRoomTypeRate.base_amount ? <span>{I18n.t('number.currency.format.unit')}{numeral(this.props.dailyRoomTypeRate.base_amount / 100).format('0,000.00')}</span> : I18n.t('none')}</em>
							  	{/* {this.renderSeasonIfOverridden()}
									{this.renderAutomaticPriceRuleIfOverridden()} */}
							  </div>
							</div>
						</div>


						<div className="col-xs-6">
							<div className="form-group">
								<label>{I18n.t('min_stay')}</label>
							  <NumberSpinner name="minimum_stay" onChange={this.onChange} />
							  <div className="default-value-helper-text"><em>{this.props.dailyRoomTypeRate && this.props.dailyRoomTypeRate.minimum_stay ? this.props.dailyRoomTypeRate.minimum_stay : I18n.t('none')}</em></div>
							</div>
						</div>
					</div>
					<ModalButtons loading={this.state.loading} buttons={this.state.buttons} />
	      	<LoadingSpinner show={this.state.loading} />
	      </div>
			</div>
		);
	}

	renderAutomaticPriceRuleIfOverridden() {
		if (this.props.dailyRoomTypeRate.automatic_price_rule_id && this.props.dailyRoomTypeRate.automatic_price_rule_name) {
			return(
				<div style={{fontSize: '13px', marginTop: '1px', float: 'right'}}>

					{I18n.t('overridden_by')} <a href={this.props.dailyRoomTypeRate.automatic_price_rule_path} className="modal-iframe">{this.props.dailyRoomTypeRate.automatic_price_rule_name}</a>
				</div>
			)
		} else {
			return null;
		}
	}

	renderSeasonIfOverridden() {
		if (this.props.dailyRoomTypeRate.season_id && this.props.dailyRoomTypeRate.season_name && !this.props.dailyRoomTypeRate.automatic_price_rule_id) {
			return (
				<div style={{fontSize: '13px', marginTop: '1px', float: 'right'}}>
					{I18n.t('overridden_by')} <a href={this.props.dailyRoomTypeRate.season_path} className="modal-iframe">{this.props.dailyRoomTypeRate.season_name}</a>
				</div>
			);
		} else {
			return null;
		}
	}

	onChange(event) {
		//console.log('onChange!', event)
		// if (event.target.name == 'amount') {
		// 	console.log('setting amount', event.target.value);
		// 	this.setState({amount: event.target.value});
		// } else if (event.target.name == 'minimum_stay') {
		// 	console.log('setting min stay', event.target.value);
		// 	this.setState({minimum_stay: event.target.value});
		// }
		if (event && event.target && event.target.name && typeof event.target.value != 'undefined') {
			var newState = {};
			if (event.target.name == "amount" || event.target.name == "minimum_stay") {
				if (event.target.value != null && event.target.value > 0) {
					newState[event.target.name] = event.target.value;
					this.setState(newState);
				}
			} else {
				newState[event.target.name] = event.target.value;
				this.setState(newState);

			}
		}
	}

	onSave(event) {
		var self = this;

		if (event && event.stopPropagation && event.preventDefault) {
			event.stopPropagation();
			event.preventDefault();
		}

		this.setState({loading: true});

    $.ajax({
      type: 'POST',
      url: this.props.saveRoomTypePriceOverridePath,
      data: {
        date: DateHelper.printDateToScreen(this.props.date, 'yyyy-MM-dd'),
      	amount: this.state.amount,
				original_amount: this.props.amount,
				original_minimum_stay: this.props.minimum_stay,
      	minimum_stay: this.state.minimum_stay,
      	room_type_id: this.props.room_type.id,
      }
    }).done((data) => {
    	parent.refresh_data(I18n.t('override_saved_successfully'))
    });
	}

}

export default RatesDashboardRoomTypeDateOverrides
